import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IInstallationPoint } from '@model/installationPoint';

import { apiClient } from '@services/apiClient';

interface IResponse {
  installationPoint: IInstallationPoint;
}

export const listByInstPointKey = (pointId?: number) => ['listByInstPoint', pointId];
export const listByInstPointFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/installation-point/get-installation-point-info`, {
    params: {
      installationPointId: queryKey[1],
    },
  });

const listByInstPointSelect = ({ data }: AxiosResponse<IResponse>) => data?.installationPoint;

export const useListByInstPointQuery = ({ pointId }: { pointId?: number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: listByInstPointKey(pointId),
    queryFn: listByInstPointFn,
    enabled: !!pointId,
    select: listByInstPointSelect,
    placeholderData: {
      data: {
        installationPoint: {},
      },
    },
  });
};
